// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1vYjU","container":"styles_container__H_8SV","title":"styles_title__3FBb2","wrapper":"styles_wrapper__15_IJ","answer":"styles_answer__QI5Ne"};